import React, { Component, useState } from 'react';
import { Collapse, Input, Card, CardBody } from 'reactstrap';
import { withRouter } from 'react-router';
import AppButton from './AppButton';
import AuthorityToLeave from './AuthorityToLeave';
import ReceiverInstructions from './ReceiverInstructions';
import { Address } from './Address';
import { StatusSummary } from './StatusSummary';
import { WhatsNextDisplay } from './WhatsNextDisplay';
import './Offer.scss';
import { OfferDate } from './OfferDate';
import { SpeechBubble } from './SpeechBubble';
import { useConfig } from '../hooks/useConfig';
import queryString from 'query-string'
import AuthService from "../services/AuthService";
import ConfigService from "../services/ConfigService";
import googleLogo from './google_g.png';
import styles from './Offer.module.scss';

function Header(props) {

    var getHeaderText = (offer, shipment) => {
        //console.log("headertext:", offer.status, shipment.status);
        if (shipment.status === "Cancelled")
            return "CONTACT SENDER";

        if (shipment.status === "Rejected")
            return "RETURNED";

        if (shipment.status === "Delivered" || shipment.status === "ManualPOD")
            return "DELIVERED";

        if (shipment.status === "OFD" || shipment.status === "OFDOffSchedule")
            return "ON THE WAY";

        if (shipment.status === "DriverNear")
            return "CLOSE TO HOME";

        if (offer.status === "Ordered")
            return "Ordered";

        if (offer.status === "ConfirmChange")
            return "THINGS HAVE CHANGED";

        if (offer.status === "Rebook")
            return "REBOOK A TIME";

        if (shipment.status === "PartialPOD")
            return "ALMOST THERE";

        if (offer.status.startsWith("Offer"))
            return "BOOK A TIME";
        if (offer.status === "Declined" || offer.status === "Contact" || offer.status === "Change")
            return "LET'S TALK";
        if (offer.status === "Accepted")
            return "BOOKED";

        return "DETAILS";
    }

    return <div className="header">My Delivery: {getHeaderText(props.offer, props.shipment)}</div>;
}

function OfferStatusArea(props) {

    let config = useConfig();

    if (props.shipment.status === "Cancelled")
        return <SpeechBubble text="Please contact the sender regarding this delivery" />;

    if (props.shipment.status === "Rejected")
        return <SpeechBubble text="Delivery Returned" />;

    if (props.shipment.status === "ManualPOD")
        return null;

    console.log("Invite review?", props.config?.reviewUrl, props.offer)
    if (props.shipment.status === "Delivered")
        if (props.offer.status !== "Rated")
            return null;
        else
            return <SpeechBubble tapIcon={googleLogo} tapText="Tap here to leave us a google review" tapUrl={props.offer.invite_review ? config?.reviewUrl : null}>
                <span>Thank you for your feedback</span>
            </SpeechBubble>;

    if (props.shipment.status === "OFD" || props.shipment.status === "OFDOffSchedule" || props.shipment.status === "DriverNear") {

        var offer = (props.offer.offers.length > 0 && props.offer.offers[0]) || null;

        if (props.isOnWayIncorrectDay(offer, props.shipment))
            return <SpeechBubble text="On its way for delivery today" />;

        if (props.isOnWayCorrectDay(offer, props.shipment))
            return <SpeechBubble content={(
                <React.Fragment>
                    <span>On its way for delivery</span><br />
                    <OfferDate onWay={props.shipment.status === "DriverNear"} start_time={props.offer.offers[0].start_time} end_time={props.offer.offers[0].end_time}></OfferDate>
                </React.Fragment>)} />;
    }

    if (props.offer.status === "ConfirmChange" && props.offer.offers.length > 0)
        return <SpeechBubble content={<React.Fragment>
            <span>Your agreed delivery date</span><br />
            <OfferDate dateOnly={props.shipment.atl_provided === "Customer"} start_time={props.offer.offers[0].start_time} end_time={props.offer.offers[0].end_time}></OfferDate>
        </React.Fragment>} />;

    if (props.offer.status === "Ordered")
        return <SpeechBubble text="We will be in touch shortly with options for your delivery" />;

    if (props.offer.status === 'Expired')
        return <SpeechBubble content={<React.Fragment><span>SORRY PREVIOUS OFFERS HAVE EXPIRED</span><br />
            <span className="small">We'll be in touch shortly with options for your delivery</span></React.Fragment>} />;

    if (props.offer.status === "Rebook" || props.offer.status === "ClearedOffer")
        return <SpeechBubble content={<React.Fragment><span>SORRY SOMETHING HAS GONE WRONG</span><br />
            <span className="small">We'll be in touch shortly with options for your delivery</span></React.Fragment>} />;

    if (props.shipment.status === "PartialPOD")
        return <SpeechBubble text="On its way for delivery today" />;

    if (props.offer.status.startsWith("Offer"))
        return null;

    if (props.offer.status === "Accepted")
        return <SpeechBubble content={<React.Fragment>
            <span>Your agreed delivery date</span><br />
            <OfferDate dateOnly={props.shipment.atl_provided === "Customer"} start_time={props.offer.offers[0].start_time} end_time={props.offer.offers[0].end_time}></OfferDate>
        </React.Fragment>} />;

    if (props.offer.status === "Declined")
        return <SpeechBubble content={<React.Fragment><span>TIME DOESN'T SUIT</span><br />
            <span className="small">We will be in touch with a delivery date</span></React.Fragment>} />;

    //default:
    return <SpeechBubble text="We will be in touch shortly with options for your delivery" />;
}

function OfferShipmentDetails(props) {
    return (
        <div className={styles.OfferShipmentDetails}>
            <div className="edit-icon-right">
                <Address label="We have a parcel for you from" address={{ line1: props.shipment.from.line1 }} />
                <div><i className="icon-x-app-icon connote"></i></div>
            </div>
            <Address
                label="Your delivery address"
                address={props.shipment.to}
                atlInstructions={props.shipment.atlInstructions}
                receiverInstructions={props.shipment.receiverInstructions} />
            <div>
                <label>Consignment Number</label>
                <div className="fakeinput">
                    {props.shipment.connote}
                </div>
            </div>
        </div>
    );
}

const ContactButton = (props) => {

    const config = useConfig();

    if (props.commercialRestrictions) {
        return (
            <a href={`tel:${config?.contactPhoneNumber}`} className={styles.ContactPhoneButton}>
                <AppButton iconName="icon-button-speech" actionText="Contact Fliway" ajaxInProgress={false}
                    footer="I need to talk to Fliway about this"/>
            </a>
        );
    }

    return (
        <AppButton iconName="icon-button-speech" actionText="Contact me" ajaxInProgress={props.busy}
            onClick={props.onClick} footer="I need to talk to Fliway about this" />
    );
}

class Offer extends Component {
    static displayName = Offer.name;

    constructor(props) {
        super(props);
        const { match: { params } } = props;
        this.state = {
            notFound: false,
            shipment: {
                connote: "",
                status: "",
                from: {},
                to: {},
                atl_permitted: false,
                atl_provided: "No"
            },
            offer: {
                status: "",
                offers: [{}]
            },
            loggedin: false,
            location: {},
            shipmentStates: [
                { label: "Ordered" }, { label: "PickedUp" },
                { label: "OFD" }, { label: "OFDOffSchedule" }, { label: "DriverNear" }, { label: "Delivered" },
                { label: "PartialPOD" }, { label: "ManualPOD" }, { label: "Rejected" }, { label: "Cancelled" }
            ],
            offerStates: [
                { label: "Offer1" }, { label: "Declined" }, { label: "Accepted" }, { label: "Contact" },
                { label: "Offer2" }, { label: "Change" }, { label: "Rebook" }, { label: "Expired" }, { label: "Ordered" }
            ],
            enableReceiverInstructions: false,
            params: params || { jobid: null },
            qs: queryString.parse(this.props.location.search),
            config: {
                termsAndConditions: {
                    // default but will be overriden by config
                    authorityToLeaveUrl: "http://www.fliway.com/media/5413/fliway-termsandconditions-dec17.pdf"
                }
            },
            busy: true,
            savingReceiverInstructions: false
        };

        this.myRef = React.createRef();
    }

    async componentDidMount() {
        let userTask = this.getUser();
        let configTask = ConfigService.getConfig();
        await this.loadOffer();
        let user = await userTask;
        let config = await configTask;
        if (user) {
            this.setState({ loggedin: true });
        }
        console.log('config!', config);
        this.setState({ config: { ...this.state.config, ...config } });
    }

    getUser = async () => {
        if (!this.authService)
            this.authService = await AuthService.getInstance();
        return await this.authService.getUser();
    }

    async loadOffer() {
        let offer;
        if (this.state.params.jobid === "testing")
            offer = {
                shipment: {
                    connote: "TESTING",
                    status: 0,
                    from: { line1: "Somewhere" },
                    to: {},
                    atl_permitted: true,
                    atl_requested: false,
                    atl_provided: "No",
                    status: "Delivered",
                    rate_my_delivery: true
                    
                },
                offer: {
                    offers: [{ start_time: new Date() }],
                    status: "Rated",
                    invite_review: true
                }
            };
        else
            offer = await (await window.fetch('api/offer/' + this.state.params.jobid)).json();
        this.setOffer(offer);
        this.setState({ busy: false });
        return offer;
    }

    setOffer(newOffer) {
        console.log('offer details', newOffer);
        if (newOffer.location) {
            this.setState({ location: newOffer.location });
        }
        if (newOffer.shipment) {
            this.setState({ shipment: newOffer.shipment });
            // var newStatus = newOffer.shipment.shipment.status;
            // // if new status is drivernear, but it's not trackable - treat like OFD off schedule (?)
            // //if(newStatus === "DriverNear" && !this.isTrackable(newStatus, newOffer.location))
            // //    newStatus = "OFDOffSchedule";
            // this.setState({shipment: {...shipment, status: newStatus}});
        }
        if (newOffer.offer) {
            this.setState({ offer: newOffer.offer });
        }
        else if (newOffer.status === 404) {
            this.setState({
                notFound: true
            });
        }
    }

    handleAction = async (newStatus, seloffer) => {
        //console.log('Attempting to set status on offer...', this.state.offer.offers[0], newStatus);
        seloffer = seloffer || this.state.offer.offers[0];
        seloffer.status = newStatus;
        const offer = await this.postData(`api/offer/${this.state.params.jobid}`, seloffer);
        this.setOffer(offer);
    }

    startAtl = async () => {
        try {
            let user = "Anon";
            if (this.state.shipment.atl_provided != "Customer") {
                user = await this.authService.getAuthenticatedUser(true);
            }
            if (user) {
                // now set the state to confirm Atl (with instruction if needed)        
                this.setState({ shipment: { ...this.state.shipment, confirmAtl: true } });
                this.myRef.current.scrollIntoView({ behavior: "smooth" });
            }
        }
        catch (err) {
            console.error(err);
            return;
        }
    }

    giveAtl = async () => {
        let user;
        try {
            if (this.state.shipment.atl_provided != "Customer") {
                //check if we're logged in
                user = await this.authService.getAuthenticatedUser(true);
            }
        }
        catch (err) {
            console.error('Please login (or register) to do this.');
            return;
        }
        this.props.setGlobalBusy();
        var offer = await this.postData(`api/offer/${this.state.params.jobid}/atl` + (!user ? "/instruction" : ""),
            { instruction: this.state.shipment.atlInstruction }, user?.access_token);
        console.log('got offer back from atl endpoint', offer);
        // atl button should accept first offer too (but only if status is an offer)
        if (this.state.offer.status.startsWith("Offer"))
            await this.handleAction("Accepted", this.state.offer.offers[0]);
        else
            this.setOffer(offer);
        this.props.clearGlobalBusy();
    }

    saveInstructions = async (instructions) => {

        this.setState({ savingReceiverInstructions: true });

        var offer = await this.postData(
            `api/offer/${this.state.params.jobid}/receiverInstructions`,
            {
                instructions: instructions
            }
        );

        console.log('got offer back from receiver instructions endpoint', offer);

        this.setOffer(offer);

        this.setState({ enableReceiverInstructions: this.state.shipment.receiverInstructions === null });

        this.setState({ savingReceiverInstructions: false });
    };

    postData(url = '', data = {}, idToken = null) {
        const headers = new Headers();
        headers.append('Content-Type', 'application/json');
        if (idToken)
            headers.append('Authorization', `Bearer ${idToken}`);

        return fetch(url, {
            method: 'POST',
            mode: 'cors',
            cache: 'no-cache',
            credentials: 'same-origin',
            headers: headers,
            redirect: 'follow',
            referrer: 'no-referrer',
            body: JSON.stringify(data),
            })
            .then(response => {
                if (!response.ok) {
                    if (response.status == "409") {
                        alert("Sorry this is out of date; Tap to refresh.");
                        return this.loadOffer();
                    }
                    else {
                        alert("Error: " + response.status);
                        return this.state.offer;
                    }
                }
                return response.json();
            });
    }

    

    isTrackable(shipment, location) {
        //console.log('checking trackability', shipment.status, location);
        if (!shipment.status || !location || shipment.status !== "DriverNear")
            return false;
        if (location.message && location.message !== "GPS Stale") {
            //console.log(`not trackable because: ${location.message}`);
            return false;
        }
        return true;
    }

    isOnWayCorrectDay(offer, shipment) {
        var currentDate = new Date();
        currentDate.setHours(0, 0, 0, 0);
        var offerDate = new Date(offer.start_time);
        offerDate.setHours(0, 0, 0, 0);
        // Driver near has to be on the same day, OFD just has to be before or on the same day
        if ((shipment.status === "DriverNear" && currentDate.getTime() === offerDate.getTime())
            || (shipment.status === "OFD" && currentDate.getTime() <= offerDate.getTime()))
            return true;

        return false;
    }

    isOnWayIncorrectDay(offer, shipment) {

        if (shipment.status === "OFDOffSchedule" || offer === null)
            return true;

        var currentDate = new Date();
        currentDate.setHours(0, 0, 0, 0);
        var offerDate = new Date(offer.start_time);
        offerDate.setHours(0, 0, 0, 0);
        // OFD incorrect day
        if (shipment.status === "OFD" && currentDate.getTime() > offerDate.getTime())
            return true;

        // driver near but incorrect day
        if (shipment.status === "DriverNear" && (currentDate.getTime() !== offerDate.getTime()))
            return true
        return false;
    }

    getActionArea() {
        if (this.state.shipment.status === "Cancelled")
            return null;

        if (this.state.shipment.status === "Rejected")
            return null;

        if (this.state.shipment.status === "ManualPOD")
            return null;

        if (this.state.shipment.status === "Delivered")
            if (this.state.offer.status === "Rated" || this.state.shipment.rate_my_delivery !== true)
                return null
            else
                return <AppButton iconName="icon-button-rate" actionText="Rate my delivery" header="Tap here to" footer="We would love to get your feedback"
                    onClick={() => { this.props.history.push('../../r/' + this.state.params.jobid) }} />;

        if (this.state.shipment.status === "OFD" || this.state.shipment.status === "OFDOffSchedule" || this.state.shipment.status === "DriverNear") {
            var offer = (this.state.offer.offers.length > 0 && this.state.offer.offers[0]) || null;

            if (this.isOnWayIncorrectDay(offer, this.state.shipment.status, this.state.offer.status))
                return null;

            if (this.isOnWayCorrectDay(offer, this.state.shipment.status, this.state.offer.status))
                return null;
        }

        if (this.state.offer.status === "Ordered")
            return null;

        if (this.state.offer.status === 'Expired')
            return null;

        if (this.state.offer.status === "Rebook" || this.state.offer.status === "ClearedOffer")
            return null;

        if (this.state.shipment.status === "PartialPOD")
            return null;

        if (this.state.offer.status.startsWith("Offer"))
            return <React.Fragment>
                {this.state.offer.offers.map((value, index) => {
                    return <div key={index} className="primary-action-area agreed-area">
                        <div className={"proposed-time" + (this.state.offer.offers.length > 1 ? " small" : "")}>
                            <OfferDate start_time={value.start_time} end_time={value.end_time}></OfferDate>
                        </div>
                        <i className="icon-arrow-right"></i>
                        <AppButton className={(this.state.offer.offers.length > 1 ? "small" : "")} iconName="icon-button-tick" actionText="Accept" header="Tap here to" highlight
                            onClick={() => this.handleAction("Accepted", value)} ajaxInProgress={this.props.busy}
                            footer={this.state.offer.offers.length <= 1 ? <span>your proposed<br />delivery date</span> : <span>this delivery date</span>} />
                    </div>;
                })}
            </React.Fragment>;

        if (this.state.offer.status === "Accepted")
            return null;

        if (this.state.offer.status === "Declined")
            return null;

        //default:
        return null;
    }

    // check if any additional services
    showAdditionalServices = () => {
        if (this.state.offer.status === "ConfirmChange")
            return false;

        // if this is true we will be showing the additional options button so don't want the addtional service button
        if ((this.state.offer.status === "Offer1" || this.state.offer.status === "Ordered" || this.state.offer.status === 'Expired') &&
            (this.state.shipment.status !== 'OFD' && this.state.shipment.status !== 'OFDOffSchedule') &&
            ((this.state.shipment.allow_redirect === true) || (this.state.shipment.additionalServices && this.state.shipment.additionalServices.length > 0)))
            return false;

        let map = this.state.config?.maps?.availableUntilToShipmentStatus;
        let addSvcs = this.state.shipment.additionalServices;
        console.log('checking additional services', map, addSvcs);
        if (addSvcs?.length > 0 && map?.length > 0 && this.state.offer.status !== "Offer2") {
            // check if any additional services are selectable
            return addSvcs.some((svc) => {

                // and the shipment is in a state which allows selecting of this additional service
                let matchingMap = map.find(m => m.until === svc.available_until);
                console.log('matching map for service', svc, matchingMap);
                if (matchingMap?.states.some(s => s === this.state.shipment.status) || svc.paid_by === 'S' || svc.paid_by === 'R')
                    return true;

            });
        }
        return false;
    };

    async startRedirect() {
        //check if we're logged in
        try {
            await this.authService.getAuthenticatedUser(true);
            this.props.history.push('../../rd/' + this.state.params.jobid)
        }
        catch (err) {
            console.error(err);
            return;
        }
    }

    receiverInstructions_onClick = () => {
        this.setState({ enableReceiverInstructions: !this.state.enableReceiverInstructions });
    };

    render() {
        return (
            this.state.notFound === true ?
                <div>
                    <div className="header">My Delivery: NOT FOUND</div>
                    <div style={{ textAlign: "center" }}>Shipment Not Found</div>
                </div> :
                <div>
                    {
                        <div style={{ display: 'none', width: '100%', marginBottom: '0.2em' }}>
                            <div style={{ display: 'table-cell', width: '48%' }}>
                                <label>shpt:</label>
                                <select value={this.state.shipment.status}
                                    onChange={(e) => this.setState({ shipment: { ...this.state.shipment, status: e.target.value } })}>
                                    {this.state.shipmentStates.map((ss, index) => <option key={`${ss.value}_${index}`} value={ss.label}>{ss.label}</option>)}
                                </select>
                            </div>
                            <div style={{ display: 'table-cell', width: '35%' }}>
                                <label>ofr:</label>
                                <select value={this.state.offer.status}
                                    onChange={(e) => this.setState({ offer: { ...this.state.offer, status: e.target.value } })}>
                                    {this.state.offerStates.map((os, index) => <option key={`${os.label}_${index}`} value={os.label}>{os.label}</option>)}
                                </select>
                            </div>
                            <div style={{ display: 'table-cell', width: '17%' }}>
                                <label>atl:</label>
                                <input type="checkbox" value={this.state.shipment.atl_requested}
                                    onClick={(e) => { this.setState({ shipment: { ...this.state.shipment, atl_requested: !this.state.shipment.atl_requested } }); }}>
                                </input>
                            </div>
                        </div>
                    }
                    <Header offer={this.state.offer} shipment={this.state.shipment} />
                    {this.state.busy && <div>Loading...</div>}
                    {!this.state.busy &&
                        <div className="view-body">
                            <OfferStatusArea
                                shipment={this.state.shipment}
                                offer={this.state.offer}
                                isOnWayCorrectDay={this.isOnWayCorrectDay}
                                isOnWayIncorrectDay={this.isOnWayIncorrectDay}
                                />
                            {(this.state.offer.offers.length <= 1 || this.state.offer.status !== 'Offer2') &&
                            <OfferShipmentDetails shipment={this.state.shipment} />
                            }
                            <div className="action-area">
                                <div className="clearfix"></div>
                                {this.getActionArea()}
                            </div>
                            <AuthorityToLeave shipment={this.state.shipment} startAtl={this.startAtl}
                                myRef={this.myRef} offer={this.state.offer} config={this.state.config}
                                updateShipment={e => this.setState({ shipment: { ...this.state.shipment, ...e } })}
                                busy={this.props.busy} giveAtl={this.giveAtl}></AuthorityToLeave>
                            <WhatsNextDisplay shipment={this.state.shipment} />
                            <div className="action-area">
                                <div className="clearfix">
                                    {(this.state.shipment.status === "Ordered" || this.state.shipment.status === "PickedUp") &&
                                        <React.Fragment>
                                            {this.state.shipment.allowReceiverInstructions && (this.state.shipment.receiverInstructions === null) &&
                                                <AppButton
                                                    iconName="icon-button-change"
                                                    actionText="Instructions for our driver"
                                                    footer="Tap to add some instructions for our driver"
                                                    onClick={this.receiverInstructions_onClick}
                                                    />
                                                
                                            }
                                            {this.state.enableReceiverInstructions &&
                                                <ReceiverInstructions
                                                    isOpen={this.state.enableReceiverInstructions}
                                                    ajaxInProgress={this.state.savingReceiverInstructions}
                                                    onClose={e => this.setState({ enableReceiverInstructions: false })}
                                                    saveInstructions={this.saveInstructions}
                                                    />
                                            }
                                            {(this.state.offer.status.startsWith("Offer") && this.state.offer.offers.length <= 1 || this.state.offer.status === "ConfirmChange") &&
                                                <AppButton iconName="icon-button-timer" onClick={() => this.handleAction(this.state.offer.status === "Offer2" ? "Contact" : "Declined")}
                                                    actionText="Time not suitable?" footer="Tap for new date and time" />
                                            }
                                            {(this.state.offer.status === "ConfirmChange" && this.state.shipment.allow_redirect === true) &&
                                                <AppButton iconName="icon-button-change-address" onClick={() => this.startRedirect()}
                                                    actionText="Change Delivery Address" footer="Deliver elsewhere. Additional charges may apply" />}
                                            {((this.state.offer.status === "Offer1" || this.state.offer.status === "Ordered" || this.state.offer.status === 'Expired') && (this.state.shipment.allow_redirect === true ||
                                                (this.state.shipment.additionalServices && this.state.shipment.additionalServices.length > 0))) &&
                                                <AppButton iconName="icon-button-delivery-options" onClick={() => { this.props.history.push('../../ao/' + this.state.params.jobid) }}
                                                    actionText="Additional Options" footer="Change delivery address, other services" />
                                            }
                                            {this.state.offer.status === "Accepted" && this?.state?.shipment?.commercialRestrictions !== true &&
                                                <React.Fragment>
                                                    <AppButton iconName="icon-button-change" actionText="Things have changed?" ajaxInProgress={this.props.busy}
                                                        onClick={() => this.setState({ offer: { ...this.state.offer, status: "ConfirmChange" } })} footer="Tap for new date and time" />
                                                </React.Fragment>
                                            }
                                            {(this.state.offer.status.startsWith("Offer") || this.state.offer.status === "Accepted") &&
                                                <ContactButton onClick={() => this.handleAction("Contact")} busy={this.props.busy} commercialRestrictions={this.state?.shipment?.commercialRestrictions
                                                } />
                                            }
                                        </React.Fragment>}
                                    {this.showAdditionalServices() &&
                                        <AppButton iconName="icon-button-delivery-options" onClick={() => { this.props.history.push('../../as/' + this.state.params.jobid) }}
                                            actionText="Additional Services" footer="Tap for additional services" />}
                                    {(this.isTrackable(this.state.shipment, this.state.location)) &&
                                        <AppButton iconName="icon-button-map" header="Tap here to" actionText="Track delivery"
                                            onClick={() => { this.props.history.push('../../t/' + this.state.params.jobid) }} />
                                    }
                                    {(this.state.loggedin === true && this.state.offer.status !== "ConfirmChange") &&
                                        <AppButton function iconName="icon-function-left-arrow-up" actionText="Back"
                                            onClick={() => { this.props.history.push('../../shipments') }} footer="Return to my jobs" />
                                    }
                                    {(this.state.offer.status === "ConfirmChange") &&
                                        <AppButton function iconName="icon-function-left-arrow-up" actionText="Back"
                                            onClick={() => this.setState({ offer: { ...this.state.offer, status: "Accepted" } })} footer="Return to offer" />
                                    }
                                </div>
                            </div>
                            <StatusSummary shipment={this.state.shipment} />
                        </div>}
                </div>
        );
    }
}

export default withRouter(Offer);
